import {ReactNode, useCallback, useState} from 'react';

import {LoadingContext} from '../../contexts/LoadingContext/LoadingContext';

interface Props {
  children: ReactNode;
}

export const LoadingProvider = ({children}: Props) => {
  const [loading, setLoading] = useState(false);
  const [delay, setDelay] = useState(false);
  const [delayTimer, setDelayTimer] = useState<NodeJS.Timeout>();

  const setLoadingContext = useCallback(
    (isLoading: boolean) => {
      if (!loading && !delay && isLoading) {
        clearTimeout(delayTimer);
        setDelay(true);
        setDelayTimer(
          setTimeout(() => {
            setDelay(false);
          }, 500)
        );
      }

      setLoading(isLoading);

      return () => clearTimeout(delayTimer);
    },
    [setLoading, delay, loading, delayTimer]
  );
  return (
    <LoadingContext.Provider value={{loading: loading || delay, setLoadingContext}}>{children}</LoadingContext.Provider>
  );
};
